import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import { Base } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/components/HistoryPanel/CollapsableItemDetails/Base'
import { usePromotions } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/components/HistoryPanel/hooks/usePromotions'

interface Props {
  contractVersionIds: string[]
}

export const Promotions = ({ contractVersionIds }: Props) => {
  const { fetch, data, loading } = usePromotions()

  const handleFetch = (itemsPerPage: number, lastCursor?: string) => {
    fetch({ contractVersionIds, itemsPerPage, lastCursor })
  }

  const connection = data?.contracts.contractVersionsConnection

  const formattedData = useUnsafeMemo(() => {
    return (
      connection?.nodes.map((node) => ({
        id: String(node.id),
        date: node.effectiveOn,
        employeeName: String(node.employee?.fullName),
        employeeId: String(node.employee?.id),
        contractVersionId: String(node.id),
      })) ?? []
    )
  }, [data])

  const formattedPagination = useUnsafeMemo(() => {
    return {
      hasNextPage: connection?.pageInfo.hasNextPage ?? false,
      endCursor: connection?.pageInfo.endCursor ?? '',
      totalCount: connection?.totalCount ?? 0,
    }
  }, [data])

  return (
    <Base
      fetch={handleFetch}
      loading={loading}
      count={contractVersionIds.length}
      data={formattedData}
      type="promotions"
      pagination={formattedPagination}
    />
  )
}
